// extracted by mini-css-extract-plugin
export default {"CreateProviderConfigModalDialog":"CreateProviderConfigModalDialog_CreateProviderConfigModalDialog__tCu5o"};